<template>
    <section class="accessories-informations">
        <h2 v-if="data.title" v-html="translate(data.title)"/>
        <div class="execution-zones">
            <span class="title"/>
            <span class="title">{{ translate(data.inside_header) }}</span>
            <span class="title">{{ translate(data.outside_header) }}</span>
        </div>
        <div v-if="data.values" class="elements-container">
            <div v-for="(element, key) in data.values" class="element execution-atex">

                <span class="title" v-html="translate(element.title)"/>
                <template v-if="element.inside_variable !== undefined">

                    <template v-if="!isEditable">
                        <span v-if="element.title_+data.inside_suffix" class="value"
                              v-html="getVariableDefaultValue(element.title+data.inside_suffix)"/>
                    </template>

                    <offer_editable_property_value
                            v-else
                            :initialData="getVariable(element.title+data.inside_suffix).variableValues"
                            :defaultKey="getVariable(element.title+data.inside_suffix).variableDefaultKey"
                            :elementKey="element.title+data.inside_suffix"/>

                </template>
                <template v-else-if="key === 'ex_signature'">
                    <span class="value one-line" v-if="zone.inside !=='-'">
                        <span v-if="!sign_inside_edit || !isAdmin" v-html="ex_signature.inside" @click="sign_inside_edit = true"/>
                        <input type="text" @blur="sign_inside_edit = false" v-else class="edit-input" v-model="ex_signature.inside">
                    </span>
                    <span v-else class="value" v-html="element.inside_value"/>
                </template>
                <span v-else class="value" v-html="element.inside_value"/>
                <template v-if="element.outside_variable !== undefined">

                    <template v-if="!isEditable">
                        <span v-if="element.title+data.outside_suffix" class="value"
                              v-html="getVariableDefaultValue(element.title+data.outside_suffix)"/>
                    </template>

                    <offer_editable_property_value
                            v-else
                            :initialData="getVariable(element.title+data.outside_suffix).variableValues"
                            :defaultKey="getVariable(element.title+data.outside_suffix).variableDefaultKey"
                            :elementKey="element.title+data.outside_suffix"/>

                </template>
                <template v-else-if="key === 'ex_signature'">
                    <span class="value one-line" v-if="zone.outside !== '-'">
                        <span v-if="!sign_outside_edit || !isAdmin" v-html="ex_signature.outside" @click="sign_outside_edit = true"/>
                        <input type="text" @blur="sign_outside_edit = false" v-else class="edit-input" v-model="ex_signature.outside">
                    </span>
                    <span v-else class="value" v-html="element.outside_value"/>
                </template>
                <span v-else class="value" v-html="element.outside_value" />
            </div>
        </div>
        <div class="comments">
            <div class="comment hide-in-result-form" v-if="comment">{{ comment }}</div>
        </div>
    </section>
</template>

<script>
    import Offer_editable_property_value from "../offers/offer_editable_property_value";

    export default {
        name: "customTableComponent",
        props: ['data','comment'],
        components: {Offer_editable_property_value},
        data() {
            return {
                sign_inside_edit: false,
                sign_outside_edit: false,
                /* NVS-116
                exClass: {
                    1: 'IIC',
                    2: 'IIC',
                    21: 'IIIC',
                    22: 'IIIB'
                },
                gbClass: {
                    1: 'Gb',
                    2: 'Gc',
                    21: 'Db',
                    22: 'Dc'
                },
                device: {
                    inside: '-',
                    outside: '-',
                },
                temperature_class: {
                    inside: '-',
                    outside: '-',
                },
                explosion_protection: {
                    inside: '-',
                    outside: '-',
                },
                */
                ex_signature: {
                    inside: '-',
                    outside: '-',
                },
                changes: 0,
                zone: {
                    inside: '-',
                    outside: '-'
                },
                variables: {},
            }
        },
        methods: {
            translate(code, displayErrors = true) {
                let arg = {
                    type: 'translate',
                    code: code,
                    displayErrors: displayErrors,
                    out: ""
                }

                this.$store.commit(arg);

                return arg.out;
            },

            // NVS-110 - utworzone
            /* NVS-116 - wyłączone
            updateExSignature (element, place) {
                element[place + '_edit'] = false;
                this.ex_signature[place] = '';
                let zone = 0;
                for(const [key, value] of Object.entries(this.data.values)) {
                    if(key == 'zone') zone = value[place + '_value'];
                    if(key != 'zone' && key != 'ex_signature') this.ex_signature[place] += value[place + '_value'] + ' ';
                    if(key == 'ex_signature') this.ex_signature[place] += this.gbClass[parseInt(zone)];
                }
            },
            */

            setZones() {
                this.zone.inside = 0;
                this.zone.outside = 0;

                setTimeout(() => {
                    let atex = this.$store.state.productCard.custom.execution.values;
                    this.zone.inside = atex.zone.inside_value;
                    this.zone.outside = atex.zone.outside_value;
                    /* NVS-116
                    this.device.inside = atex.device_category.inside_value;
                    this.device.outside = atex.device_category.outside_value;

                    this.temperature_class.inside = atex.temperature_class.inside_value;
                    this.temperature_class.outside = atex.temperature_class.outside_value;

                    this.explosion_protection.inside = atex.anti_explosion_protection_type.inside_value;
                    this.explosion_protection.outside = atex.anti_explosion_protection_type.outside_value;
                    */
                    this.ex_signature.inside = atex.ex_signature.inside_value;
                    this.ex_signature.outside = atex.ex_signature.outside_value;

                }, 10);
            },

            getVariable(code) {
                let arg = {
                    type: 'getVariable',
                    code: code,
                    out: ""
                }

                this.$store.commit(arg);
                if (arg.out === '' || null) {
                    return {variableTranslation: code, variableDefaultKey: 0, variableValues: []};
                }
                return arg.out;
            },
        },

        mounted() {
            this.setZones();
            this.variables = JSON.parse(JSON.stringify(this.$store.state.productCard.custom.variables));
            this.$store.watch((state, getters) => JSON.stringify(state.productCard.custom.variables), (val) => {
                this.variables = JSON.parse(val);
            })
        },

        computed: {
            isEditable() {
                return this.$store.getters.isOfferEditable;
            },

            isAdmin() {
                return this.$store.getters.getUserRole == 'admin'
            },

            getVariableDefaultValue() {
                return function (code) {
                    if (this.$store.state.productCard.custom.variables.hasOwnProperty(code)) {
                        let data = this.getVariable(code);
                        let value = data.variableValues.find(x => x.code === this.$store.state.productCard.custom.variables[code]);
                        if (value !== undefined) {
                            return value.value;
                        }
                    }
                    return this.$store.getters.getVariableDefaultValue(code);

                }
            },
        },
    }
</script>

<style scoped>
    .one-line {
        white-space: nowrap;
    }
</style>